import React from "react";
import { ConfigProvider, Button, Modal, Row } from "antd";
// import { WarningFilled } from "@ant-design/icons";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTranslation } from "react-i18next";
import {
  textTitleHeader,
  textDescHeader,
  colorAlertLogout,
  colorButtonLogOut,
  colorTextTitleMobile,
} from "../../../config/constant/color/index";

const LogOut = ({ openModalLogout, setModalLogout, handleLogOutClick }) => {
  const screens = useBreakpoint();
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs || isScallingVersion;
  const { t, i18n } = useTranslation();
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className="modal-logout"
        open={openModalLogout}
        maskClosable="false"
        closeIcon={false}
        width={424}
        style={{ maxWidth: isMobileVersion ? "90%" : "unset" }}
        onCancel={() => setModalLogout(!openModalLogout)}
        transitionName="ant-fade"
        keyboard
        centered
        footer={
          <div
            style={{
              padding: isMobileVersion ? "0 20px 20px 20px" : "0 32px 32px",
            }}
          >
            <Row
              style={{
                justifyContent: "space-between",
                flexWrap: isMobileVersion ? "nowrap" : "unset",
                gap: isMobileVersion ? "4%" : "0",
              }}
            >
              <Button
                key="no-logout"
                className="btn btn-sm btn-secondary"
                style={{
                  width: isMobileVersion ? "48%" : "170px",
                  borderRadius: "6px",
                  border: "1px solid " + colorButtonLogOut,
                  fontWeight: "500",
                  height: isMobileVersion ? "40px" : "48px",
                }}
                name="btn-cancel-logout-home"
                onClick={() => setModalLogout(!openModalLogout)}
              >
                {t("feature.home.pop_up_logout.no")}
              </Button>
              <Button
                key="yes-logout"
                className="btn btn-sm btn-secondary"
                style={{
                  width: isMobileVersion ? "48%" : "170px",
                  borderRadius: "6px",
                  border: "1px solid " + colorButtonLogOut,
                  fontWeight: "500",
                  height: isMobileVersion ? "40px" : "48px",
                }}
                name="btn-yes-logout-home"
                onClick={() => handleLogOutClick()}
              >
                {t("feature.home.pop_up_logout.yes")}
              </Button>
            </Row>
          </div>
        }
      >
        <div
          style={{
            padding: isMobileVersion ? "20px 0 0 0" : "32px 32px 0",
            margin: "0",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "23px" }}>
            <p
              style={{
                color: isMobileVersion ? colorTextTitleMobile : textTitleHeader,
                fontWeight: "500",
                fontSize: isMobileVersion ? "16px" : "22px",
                margin: 0,
              }}
            >
              {t("feature.home.pop_up_logout.are_you_sure_log_out")}
            </p>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default LogOut;
